import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider as SCThemeProvider, useTheme } from 'styled-components';
import type { RootState } from '../../../state/store';
import { getAv2Colors, type ThemeMode } from './constants';

interface Props {
  children: React.ReactNode;
}

/**
 * Nests Ask Vantage V2 color tokens on the global styled-components theme so
 * every AV2 component can read `theme.av2` and respond to light/dark mode.
 */
export const AskV2ThemeProvider: React.FC<Props> = ({ children }) => {
  const mode = useSelector((state: RootState) => state.theme?.mode || 'light') as ThemeMode;
  const parentTheme = useTheme();
  const av2 = useMemo(() => getAv2Colors(mode), [mode]);

  return (
    <SCThemeProvider theme={{ ...parentTheme, av2, mode }}>
      {children}
    </SCThemeProvider>
  );
};

export default AskV2ThemeProvider;
